import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { FullLayoutComponent } from "./layouts/full-layout/full-layout.component";

import { FullLayout_ROUTES } from "./shared/routes/full-layout.routes";
import { CommonLayout_ROUTES } from "./shared/routes/common-layout.routes";
import { MsalGuard } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';
import { VjThemeLayoutComponent } from './layouts/vj-theme-layout/vj-theme-layout.component';
import { HomeLayout_ROUTES } from './shared/routes/home-layut.routes';
import { VJDistSearchComponent } from './public-web/vjdist-search/vjdist-search.component';
const appRoutes: Routes = [
    {
        path: '',
        redirectTo: '/landing',
        pathMatch: 'full'
       
    },
    {
        path: '',
        component: VjThemeLayoutComponent,
        children: CommonLayout_ROUTES,
    },
    // {
    //     path: 'vjdistsearch',
    //     component: VJDistSearchComponent
    // },

    {
        path: '',
        component: FullLayoutComponent,
        children: FullLayout_ROUTES
    },

    
    { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {
            preloadingStrategy: PreloadAllModules,
            anchorScrolling: 'enabled',
            scrollPositionRestoration: 'enabled',
            //initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled' 
        })
    ],
    exports: [
        RouterModule
    ]
})

export class AppRoutingModule {
}
